import * as path from "path";

import { pathExists, readdir } from "fs-extra";

import { ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";

import { writeResourceFile } from "./WriteResourceFile";

export async function writeKClangFiles(
    gfv: string,
    formDirectory: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions,
    buildCacheExist?: boolean
): Promise<void> {
    await writeResourceFile(
        "FLASHNORM",
        "All.kclang",
        path.join("normalize", `${gfv}.All.kclang`),
        gfv,
        formDirectory,
        resourcesDirectory,
        parentLogger,
        buildCache,
        buildCacheOptions,
        buildCacheExist
    );

    const formDistPath = path.join(formDirectory, "normalizers");
    const kclangFiles = (await pathExists(formDistPath))
        ? (await readdir(formDistPath)).filter(x => path.extname(x) === ".kclang")
        : [];

    for (const fileName of kclangFiles) {
        await writeResourceFile(
            "KCLANGNORM",
            path.join("..", "normalizers", fileName),
            path.join("normalize", `${gfv}.${fileName}`),
            gfv,
            formDirectory,
            resourcesDirectory,
            parentLogger,
            buildCache,
            buildCacheOptions,
            buildCacheExist
        );
    }
}
